import { render, staticRenderFns } from "./TemplateFeed.vue?vue&type=template&id=53d10d75"
import script from "./TemplateFeed.vue?vue&type=script&lang=js"
export * from "./TemplateFeed.vue?vue&type=script&lang=js"
import style0 from "./TemplateFeed.vue?vue&type=style&index=0&id=53d10d75&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports